import { AxiosError } from "axios";
import { isBaseError, toBaseError } from "../../../../common/utils/base_error";
import { axiosInstance } from "../../../../common/utils/axios_instance";
import { handleAxiosResponse } from "../../../../common/utils/axios_response";
import { GetChecklistEntregaRequest, GetChecklistEntregaResponse } from "../daos/read/get_checklist_entrega";
import { GetAllChecklistEntregaRequest, GetAllChecklistEntregaResponse } from "../daos/read/get_all_checklist_entrega";
import { CreateChecklistEntregaRequest, CreateChecklistEntregaResponse } from "../daos/create/create_checklist_entrega";
import { UpdateChecklistEntregaRequest, UpdateChecklistEntregaResponse } from "../daos/update/update_checklist_entrega";
import { CopyChecklistEntregaRequest, CopyChecklistEntregaResponse } from "../daos/create/copy_checklist_entrega";
import { GetItemChecklistEntregaRequest, GetItemChecklistEntregaResponse } from "../daos/read/get_item_checklist_entrega";
import { GetAllItemChecklistEntregaRequest, GetAllItemChecklistEntregaResponse } from "../daos/read/get_all_item_checklist_entrega";
import { CreateItemChecklistEntregaRequest, CreateItemChecklistEntregaResponse } from "../daos/create/create_item_checklist_entrega";
import { UpdateItemChecklistEntregaRequest, UpdateItemChecklistEntregaResponse } from "../daos/update/update_item_checklist_entrega";
import { GetAllTermoRequest, GetAllTermoResponse } from "../daos/read/get_all_termo";
import { GetTermoByIdRequest, GetTermoByIdResponse } from "../daos/read/get_termo_by_id";
import { CreateTermoRequest, CreateTermoResponse } from "../daos/create/create_termo";
import { UpdateTermoRequest, UpdateTermoResponse } from "../daos/update/update_termo";
import { GetEntregaObraByIdRequest, GetEntregaObraByIdResponse } from "../daos/read/get_entrega_obra_by_id";
import { GetAllEntregaObraRequest, GetAllEntregaObraResponse } from "../daos/read/get_all_entrega_obra";
import { CreateEntregaObraRequest, CreateEntregaObraResponse } from "../daos/create/create_entrega_obra";
import { UpdateEntregaObraRequest, UpdateEntregaObraResponse } from "../daos/update/update_entrega_obra";
import { IEntregaObrasService } from './entrega_obras_service';
import { GetAllSatisfacaoClienteRequest, GetAllSatisfacaoClienteResponse } from "../daos/read/get_all_satisfacao_cliente";
import { CreateSatisfacaoClienteRequest, CreateSatisfacaoClienteResponse } from "../daos/create/create_satisfacao_cliente";
import { UpdateSatisfacaoClienteRequest, UpdateSatisfacaoClienteResponse } from "../daos/update/update_satisfacao_cliente";
import { DeleteSatisfacaoClienteRequest, DeleteSatisfacaoClienteResponse } from "../daos/delete/delete_satisfacao_cliente";
import { GetAllPesquisaSatisfacaoClienteRequest, GetAllPesquisaSatisfacaoClienteResponse } from "../daos/read/get_all_pesquisa_satisfacao_cliente";
import { GetByIdSatisfacaoClienteRequest, GetByIdSatisfacaoClienteResponse } from "../daos/read/get_by_id_satisfacao_cliente";
import { GetAllItemPesquisaClienteRequest, GetAllItemPesquisaClienteResponse } from "../daos/read/get_all_item_pesquisa_cliente";
import { GetPesquisaSatisfacaoDropDownRequest, GetPesquisaSatisfacaoDropDownResponse } from "../daos/read/get_pesquisa_satisfacao_drop_down";
import { CreatePesquisaSatisfacaoClienteRequest, CreatePesquisaSatisfacaoClienteResponse } from "../daos/create/create_pesquisa_satisfacao_cliente";
import { UpdatePesquisaSatisfacaoClienteRequest, UpdatePesquisaSatisfacaoClienteResponse } from "../daos/update/update_pesquisa_satisfacao_cliente";
import { DeletePesquisaSatisfacaoClienteRequest, DeletePesquisaSatisfacaoClienteResponse } from "../daos/delete/delete_pesquisa_satisfacao_cliente";
import { GetAllPesquisaSatisfacaoRequest, GetAllPesquisaSatisfacaoResponse } from "../daos/read/get_all_pesquisa_satisfacao";
import { GetEntregaObraParametrosByIdRequest, GetEntregaObraParametrosByIdResponse } from "../daos/read/get_entrega_obra_parametro";
import { GetAllEntregaObraClienteRequest, GetAllEntregaObraClienteResponse } from "../daos/read/get_all_entrega_obra_cliente";
import { CreateEntregaObraClienteRequest, CreateEntregaObraClienteResponse } from "../daos/create/create_entrega_obra_cliente";
import { GetAllEntregaObraClienteArquivoRequest, GetAllEntregaObraClienteArquivoResponse } from "../daos/read/get_all_entrega_obra_cliente_arquivo";
import { GetEntregaObraClienteArquivoByIdRequest, GetEntregaObraClienteArquivoByIdResponse } from "../daos/read/get_entrega_obra_cliente_arquivo_by_Id";
import { CreateEntregaObraClienteArquivoRequest, CreateEntregaObraClienteArquivoResponse } from "../daos/create/create_entrega_obra_cliente_arquivo";
import { UpdateEntregaObraClienteArquivoRequest, UpdateEntregaObraClienteArquivoResponse } from "../daos/update/update_entrega_obra_cliente_arquivo";
import { GetEntregaObrasClienteChecklistRequest, GetEntregaObrasClienteChecklistResponse } from "../daos/read/get_entrega_obras_cliente_checklist";
import { UpdateEntregaObrasClienteChecklistRequest, UpdateEntregaObrasClienteChecklistResponse } from "../daos/update/update_entrega_obras_cliente_checklist";
import { GetAllEntregaObraClienteArquivoAuxRequest, GetAllEntregaObraClienteArquivoAuxResponse } from "../daos/read/get_all_entrega_obra_cliente_arquivo_aux";
import { GetEntregaObraClienteArquivoAuxByIdRequest, GetEntregaObraClienteArquivoAuxByIdResponse } from "../daos/read/get_entrega_obra_cliente_arquivo_aux_by_id";
import { CreateEntregaObraClienteArquivoAuxRequest, CreateEntregaObraClienteArquivoAuxResponse } from "../daos/create/create_entrega_obra_cliente_arquivo_aux";
import { UpdateEntregaObraClienteArquivoAuxRequest, UpdateEntregaObraClienteArquivoAuxResponse } from "../daos/update/update_entrega_obra_cliente_arquivo_aux";
import { GetAllEntregaObraClienteTermoRequest, GetAllEntregaObraClienteTermoResponse } from "../daos/read/get_all_entrega_obra_cliente_termo";
import { CreateEntregaObraClienteTermoRequest, CreateEntregaObraClienteTermoResponse } from "../daos/create/create_entrega_obra_cliente_termo";
import { GetAllInformacoesEntregaObraClienteRequest, GetAllInformacoesEntregaObraClienteResponse } from "../daos/read/get_all_informacoes_entrega_obra_cliente";
import { GetInformacoesEntregaObraClienteByIdRequest, GetInformacoesEntregaObraClienteByIdResponse } from "../daos/read/get_informacoes_entrega_obra_cliente_by_id";
import { CreateInformacoesEntregaObraClienteRequest, CreateInformacoesEntregaObraClienteResponse } from "../daos/create/create_informacoes_entrega_obra_cliente";
import { UpdateInformacoesEntregaObraClienteRequest, UpdateInformacoesEntregaObraClienteResponse } from "../daos/update/update_informacoes_entrega_obra_cliente";
import { GetAllVerificacaoChecklistEntregaRequest, GetAllVerificacaoChecklistEntregaResponse } from "../daos/read/get_all_verificacao_checklist_entrega";
import { CreatePesquisaSatisfacaoRequest, CreatePesquisaSatisfacaoResponse } from "../daos/create/create_pesquisa_satisfacao";
import { DeletePesquisaSatisfacaoRequest, DeletePesquisaSatisfacaoResponse } from "../daos/delete/delete_pesquisa_satisfacao";
import { UpdatePesquisaSatisfacaoRequest, UpdatePesquisaSatisfacaoResponse } from "../daos/update/update_pesquisa_satisfacao";
import { CreatePesquisaSatisfacaoItemRequest, CreatePesquisaSatisfacaoItemResponse } from "../daos/create/create_pesquisa_satisfacao_item";
import { DeletePesquisaSatisfacaoItemRequest, DeletePesquisaSatisfacaoItemResponse } from "../daos/delete/delete_pesquisa_satisfacao_item";
import { GetAllPesquisaSatisfacaoItemRequest, GetAllPesquisaSatisfacaoItemResponse } from "../daos/read/get_all_pesquisa_satisfacao_item";
import { UpdatePesquisaSatisfacaoItemRequest, UpdatePesquisaSatisfacaoItemResponse } from "../daos/update/update_pesquisa_satisfacao_item";
import { GetPesquisaSatisfacaoByIdRequest, GetPesquisaSatisfacaoByIdResponse } from "../daos/read/get_pesquisa_satisfacao_by_id";
import { GetAllCategoriaAssistenciaRequest, GetAllCategoriaAssistenciaResponse } from "../daos/read/get_all_categoria_assistencia";
import { CreateCategoriaAssistenciaRequest, CreateCategoriaAssistenciaResponse } from "../daos/create/create_categoria_assistencia";
import { DeleteCategoriaAssistenciaRequest, DeleteCategoriaAssistenciaResponse } from "../daos/delete/delete_categoria_assistencia";
import { UpdateCategoriaAssistenciaRequest, UpdateCategoriaAssistenciaResponse } from "../daos/update/update_categoria_assistencia";
import { CreateAssistenciaTecnicaRequest, CreateAssistenciaTecnicaResponse } from "../daos/create/create_assistencia_tecnica";
import { DeleteAssistenciaTecnicaRequest, DeleteAssistenciaTecnicaResponse } from "../daos/delete/delete_assistencia_tecnica";
import { GetAllAssistenciaTecnicaRequest, GetAllAssistenciaTecnicaResponse } from "../daos/read/get_all_assistencia_tecnica";
import { GetAssistenciaTecnicaByIdRequest, GetAssistenciaTecnicaByIdResponse } from "../daos/read/get_assistencia_tecnica_by_id";
import { UpdateAssistenciaTecnicaRequest, UpdateAssistenciaTecnicaResponse } from "../daos/update/update_assistencia_tecnica";
import { GetAssistenciaCategoriaDropDownRequest, GetAssistenciaCategoriaDropDownResponse } from "../daos/read/get_assistencia_categoria_drop_down";
import { GetAllAssistenciaArquivoDiversoRequest, GetAllAssistenciaArquivoDiversoResponse } from "../daos/read/get_all_assistencia_arquivo_diverso";
import { GetAllAssistenciaCategoriaRequest, GetAllAssistenciaCategoriaResponse } from "../daos/read/get_all_assistencia_categoria";
import { GetAllAssistenciaPesquisaSatisfacaoRequest, GetAllAssistenciaPesquisaSatisfacaoResponse } from "../daos/read/get_all_assistencia_pesquisa_satisfacao";
import { GetAllAssistenciaRegistroAtendimentoRequest, GetAllAssistenciaRegistroAtendimentoResponse } from "../daos/read/get_all_assistencia_registro_atendimento";
import { CreateAssistenciaRegistroAtendimentoRequest, CreateAssistenciaRegistroAtendimentoResponse } from "../daos/create/create_assistencia_registro_atendimento";
import { UpdateAssistenciaRegistroAtendimentoRequest, UpdateAssistenciaRegistroAtendimentoResponse } from "../daos/update/update_assistencia_registro_atendimento";
import { DeleteAssistenciaRegistroAtendimentoRequest, DeleteAssistenciaRegistroAtendimentoResponse } from "../daos/delete/delete_assistencia_registro_atendimento";
import { CreateAssistenciaPesquisaSatisfacaoRequest, CreateAssistenciaPesquisaSatisfacaoResponse } from "../daos/create/create_assistencia_pesquisa_satisfacao";
import { DeleteAssistenciaPesquisaSatisfacaoRequest, DeleteAssistenciaPesquisaSatisfacaoResponse } from "../daos/delete/delete_assistencia_pesquisa_satisfacao";
import { CreateAssistenciaArquivoDiversoRequest, CreateAssistenciaArquivoDiversoResponse } from "../daos/create/create_assistencia_arquivo_diverso";
import { DeleteAssistenciaArquivoDiversoRequest, DeleteAssistenciaArquivoDiversoResponse } from "../daos/delete/delete_assistencia_arquivo_diverso";
import { UpdateAssistenciaArquivoDiversoRequest, UpdateAssistenciaArquivoDiversoResponse } from "../daos/update/update_assistencia_arquivo_diverso";
import { DownloadAssistenciaArquivoDiversoRequest } from "../daos/read/download_assistencia_arquivo_diverso";
import { GetAllEntregaPesquisaSatisfacaoRequest, GetAllEntregaPesquisaSatisfacaoResponse } from "../daos/read/get_all_entrega_pesquisa_satisfacao";
import { GetEntregaPesquisaSatisfacaoByIdRequest, GetEntregaPesquisaSatisfacaoByIdResponse } from "../daos/read/get_entrega_pesquisa_satisfacao_by_id";
import { CreateEntregaPesquisaSatisfacaoRequest, CreateEntregaPesquisaSatisfacaoResponse } from "../daos/create/create_entrega_pesquisa_satisfacao";
import { UpdateEntregaPesquisaSatisfacaoRequest, UpdateEntregaPesquisaSatisfacaoResponse } from "../daos/update/update_entrega_pesquisa_satisfacao";
import { GetEntregaObrasGraficoRequest, GetEntregaObrasGraficoResponse } from "../daos/read/get_entrega_obras_grafico";
import { GetDashboardEntregaObrasInformationRequest, GetDashboardEntregaObrasInformationResponse } from "../daos/read/get_dashboard_entrega_obras_information";
import { GetChecklistEntregaAmbienteByIdRequest, GetChecklistEntregaAmbienteByIdResponse } from "../daos/read/get_checklist_entrega_ambiente_by_id";
import { GetAllChecklistEntregaAmbienteRequest, GetAllChecklistEntregaAmbienteResponse } from "../daos/read/get_all_checklist_entrega_ambiente";
import { CreateChecklistEntregaAmbienteRequest, CreateChecklistEntregaAmbienteResponse } from "../daos/create/create_checklist_entrega_ambiente";
import { UpdateChecklistEntregaAmbienteRequest, UpdateChecklistEntregaAmbienteResponse } from "../daos/update/update_checklist_entrega_ambiente";
import { CopyChecklistEntregaAmbienteRequest, CopyChecklistEntregaAmbienteResponse } from "../daos/create/copy_checklist_entrega_ambiente";
import { RequestObjectToFormData } from "../../../../common/utils/form_data_utils";
import { DownloadEntregaObraClienteArquivoAuxRequest } from "../daos/read/download_entrega_obra_cliente_arquivo_aux";
import { DownloadEntregaObraClienteArquivoRequest } from "../daos/read/download_entrega_obra_cliente_arquivo";



/**
 * EntregaObrasService
 */
export class EntregaObrasService implements IEntregaObrasService {

    //#region ChecklistEntrega 

    async getChecklistEntregaById(request: GetChecklistEntregaRequest): Promise<GetChecklistEntregaResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/checklist-entrega/${request.idChecklistEntrega}`);
            const response = handleAxiosResponse<GetChecklistEntregaResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async getAllChecklistEntregas(request: GetAllChecklistEntregaRequest): Promise<GetAllChecklistEntregaResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/checklist-entrega/all`, request);
            const response = handleAxiosResponse<GetAllChecklistEntregaResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async deleteChecklistEntregaById(idChecklistEntrega: number): Promise<void> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/checklist-entrega/delete/${idChecklistEntrega}`);
            handleAxiosResponse<void>(result);
            return;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async createChecklistEntrega(request: CreateChecklistEntregaRequest): Promise<CreateChecklistEntregaResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/checklist-entrega/create`, request);
            const response = handleAxiosResponse<CreateChecklistEntregaResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async updateChecklistEntrega(request: UpdateChecklistEntregaRequest): Promise<UpdateChecklistEntregaResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/checklist-entrega/update`, request);
            const response = handleAxiosResponse<UpdateChecklistEntregaResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async copiaChecklistEntrega(request: CopyChecklistEntregaRequest): Promise<CopyChecklistEntregaResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/checklist-entrega/copy`, request);
            const response = handleAxiosResponse<CopyChecklistEntregaResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    //#endregion


    //#region ChecklistEntregaAmbiente

    async getChecklistEntregaAmbienteById(request: GetChecklistEntregaAmbienteByIdRequest): Promise<GetChecklistEntregaAmbienteByIdResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/checklist-entrega-ambiente/${request.idChecklistEntregaAmbiente}`);
            const response = handleAxiosResponse<GetChecklistEntregaAmbienteByIdResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async getAllChecklistEntregaAmbientes(request: GetAllChecklistEntregaAmbienteRequest): Promise<GetAllChecklistEntregaAmbienteResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/checklist-entrega-ambiente/all`, request);
            const response = handleAxiosResponse<GetAllChecklistEntregaAmbienteResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async deleteChecklistEntregaAmbienteById(idChecklistEntregaAmbiente: number): Promise<void> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/checklist-entrega-ambiente/delete/${idChecklistEntregaAmbiente}`);
            handleAxiosResponse<void>(result);
            return;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async createChecklistEntregaAmbiente(request: CreateChecklistEntregaAmbienteRequest): Promise<CreateChecklistEntregaAmbienteResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/checklist-entrega-ambiente/create`, request);
            const response = handleAxiosResponse<CreateChecklistEntregaAmbienteResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async updateChecklistEntregaAmbiente(request: UpdateChecklistEntregaAmbienteRequest): Promise<UpdateChecklistEntregaAmbienteResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/checklist-entrega-ambiente/update`, request);
            const response = handleAxiosResponse<UpdateChecklistEntregaAmbienteResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async copiaChecklistEntregaAmbiente(request: CopyChecklistEntregaAmbienteRequest): Promise<CopyChecklistEntregaAmbienteResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/checklist-entrega-ambiente/copy`, request);
            const response = handleAxiosResponse<CopyChecklistEntregaAmbienteResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    //#endregion



    //#region ItemChecklistEntrega 

    async getItemChecklistEntregaById(request: GetItemChecklistEntregaRequest): Promise<GetItemChecklistEntregaResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/itemChecklistEntrega/${request.idItemChecklistEntrega}`);
            const response = handleAxiosResponse<GetItemChecklistEntregaResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async getAllItemChecklistEntregas(request: GetAllItemChecklistEntregaRequest): Promise<GetAllItemChecklistEntregaResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/itemChecklistEntrega/all`, request);
            const response = handleAxiosResponse<GetAllItemChecklistEntregaResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async deleteItemChecklistEntregaById(idItemChecklistEntrega: number): Promise<void> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/itemChecklistEntrega/delete/${idItemChecklistEntrega}`);
            handleAxiosResponse<void>(result);
            return;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async createItemChecklistEntrega(request: CreateItemChecklistEntregaRequest): Promise<CreateItemChecklistEntregaResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/itemChecklistEntrega/create`, request);
            const response = handleAxiosResponse<CreateItemChecklistEntregaResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async updateItemChecklistEntrega(request: UpdateItemChecklistEntregaRequest): Promise<UpdateItemChecklistEntregaResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/itemChecklistEntrega/update`, request);
            const response = handleAxiosResponse<UpdateItemChecklistEntregaResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    //#endregion




    // INICIO VITOR

    //#region Termo

    async getTermoById(request: GetTermoByIdRequest): Promise<GetTermoByIdResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/termo/${request.idTermo}`);
            const response = handleAxiosResponse<GetTermoByIdResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async getAllTermos(request: GetAllTermoRequest): Promise<GetAllTermoResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/termo/all`, request);
            const response = handleAxiosResponse<GetAllTermoResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async deleteTermoById(idTermo: number): Promise<void> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/termo/delete/${idTermo}`);
            handleAxiosResponse<void>(result);
            return;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async createTermo(request: CreateTermoRequest): Promise<CreateTermoResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/termo/create`, request);
            const response = handleAxiosResponse<CreateTermoResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async updateTermo(request: UpdateTermoRequest): Promise<UpdateTermoResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/termo/update`, request);
            const response = handleAxiosResponse<UpdateTermoResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    //#endregion

    //#region  EntregaObras
    async getEntregaObraParametros(request: GetEntregaObraParametrosByIdRequest): Promise<GetEntregaObraParametrosByIdResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/entrega-obra/parametros/${request.idEntregaObra}`);
            const response = handleAxiosResponse<GetEntregaObraParametrosByIdResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getEntregaObraById(request: GetEntregaObraByIdRequest): Promise<GetEntregaObraByIdResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/entrega-obra/${request.idEntregaObra}`);
            const response = handleAxiosResponse<GetEntregaObraByIdResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }
    async getAllEntregaObra(
        request: GetAllEntregaObraRequest
    ): Promise<GetAllEntregaObraResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/entrega-obra/all`, request);
            const response = handleAxiosResponse<GetAllEntregaObraResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async deleteEntregaObraById(idEntregaObra: number): Promise<void> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/entrega-obra/delete/${idEntregaObra}`);
            handleAxiosResponse<void>(result);
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async createEntregaObra(
        request: CreateEntregaObraRequest
    ): Promise<CreateEntregaObraResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/entrega-obra/create`, request);
            const response = handleAxiosResponse<CreateEntregaObraResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async updateEntregaObra(
        request: UpdateEntregaObraRequest
    ): Promise<UpdateEntregaObraResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/entrega-obra/update`, request);
            const response = handleAxiosResponse<UpdateEntregaObraResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getEntregaObraGrafico(request: GetEntregaObrasGraficoRequest
    ): Promise<GetEntregaObrasGraficoResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/entrega-obra/grafico/${request.idEntregaObra}`);
            const response = handleAxiosResponse<GetEntregaObrasGraficoResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    // INICIO VITOR

    async getPesquisaSatisfacaoDropDown(request: GetPesquisaSatisfacaoDropDownRequest): Promise<GetPesquisaSatisfacaoDropDownResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/pesquisas-satisfacao/dropdown`);
            const response = handleAxiosResponse<GetPesquisaSatisfacaoDropDownResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    async getAssistenciaCategoriaDropDown(request: GetAssistenciaCategoriaDropDownRequest): Promise<GetAssistenciaCategoriaDropDownResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/assistencia-categorias/dropdown`);
            const response = handleAxiosResponse<GetAssistenciaCategoriaDropDownResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getAllSatisfacaoCliente(request: GetAllSatisfacaoClienteRequest): Promise<GetAllSatisfacaoClienteResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/satisfacao-clientes`, request);
            const response = handleAxiosResponse<GetAllSatisfacaoClienteResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async createSatisfacaoCliente(request: CreateSatisfacaoClienteRequest): Promise<CreateSatisfacaoClienteResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/satisfacao-clientes/create`, request);
            const response = handleAxiosResponse<CreateSatisfacaoClienteResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async updateSatisfacaoCliente(request: UpdateSatisfacaoClienteRequest): Promise<UpdateSatisfacaoClienteResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/satisfacao-clientes/update`, request);
            const response = handleAxiosResponse<UpdateSatisfacaoClienteResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    //#endregion

    async deleteSatisfacaoCliente({ idSatisfacaoCliente }: DeleteSatisfacaoClienteRequest): Promise<DeleteSatisfacaoClienteResponse> {
        try {
            const result = await axiosInstance({}).delete(`/entregaObras/satisfacao-clientes/${idSatisfacaoCliente}/delete`);
            const response = handleAxiosResponse<DeleteSatisfacaoClienteResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getAllPesquisaSatisfacaoCliente(request: GetAllPesquisaSatisfacaoClienteRequest): Promise<GetAllPesquisaSatisfacaoClienteResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/satisfacao-clientes/cliente-pesquisas`, request);
            const response = handleAxiosResponse<GetAllPesquisaSatisfacaoClienteResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getByIdSatisfacaoCliente({ idSatisfacaoCliente }: GetByIdSatisfacaoClienteRequest): Promise<GetByIdSatisfacaoClienteResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/satisfacao-clientes/${idSatisfacaoCliente}`);
            const response = handleAxiosResponse<GetByIdSatisfacaoClienteResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getAllItemPesquisaCliente(request: GetAllItemPesquisaClienteRequest): Promise<GetAllItemPesquisaClienteResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/satisfacao-clientes/itens`, request);
            const response = handleAxiosResponse<GetAllItemPesquisaClienteResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async createPesquisaSatisfacaoCliente(request: CreatePesquisaSatisfacaoClienteRequest): Promise<CreatePesquisaSatisfacaoClienteResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/satisfacao-clientes/cliente-pesquisas/create`, request);
            const response = handleAxiosResponse<CreatePesquisaSatisfacaoClienteResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async updatePesquisaSatisfacaoCliente(request: UpdatePesquisaSatisfacaoClienteRequest): Promise<UpdatePesquisaSatisfacaoClienteResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/satisfacao-clientes/cliente-pesquisas/update`, request);
            const response = handleAxiosResponse<UpdatePesquisaSatisfacaoClienteResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async deletePesquisaSatisfacaoCliente({ idPesquisaSatisfacaoCliente }: DeletePesquisaSatisfacaoClienteRequest): Promise<DeletePesquisaSatisfacaoClienteResponse> {
        try {
            const result = await axiosInstance({}).delete(`/entregaObras/satisfacao-clientes/cliente-pesquisas/${idPesquisaSatisfacaoCliente}/delete`);
            const response = handleAxiosResponse<DeletePesquisaSatisfacaoClienteResponse>(result);
            return { ...response };
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getAllPesquisaSatisfacao(request: GetAllPesquisaSatisfacaoRequest): Promise<GetAllPesquisaSatisfacaoResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/pesquisas-satisfacao`, request);
            const response = handleAxiosResponse<GetAllPesquisaSatisfacaoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getPesquisaSatisfacaoById({ idPesquisaSatisfacao }: GetPesquisaSatisfacaoByIdRequest): Promise<GetPesquisaSatisfacaoByIdResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/pesquisas-satisfacao/${idPesquisaSatisfacao}`);
            const response = handleAxiosResponse<GetPesquisaSatisfacaoByIdResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async createPesquisaSatisfacao(request: CreatePesquisaSatisfacaoRequest): Promise<CreatePesquisaSatisfacaoResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/pesquisas-satisfacao/create`, request);
            const response = handleAxiosResponse<CreatePesquisaSatisfacaoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async updatePesquisaSatisfacao(request: UpdatePesquisaSatisfacaoRequest): Promise<UpdatePesquisaSatisfacaoResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/pesquisas-satisfacao/update`, request);
            const response = handleAxiosResponse<UpdatePesquisaSatisfacaoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async deletePesquisaSatisfacao({ idPesquisaSatisfacao }: DeletePesquisaSatisfacaoRequest): Promise<DeletePesquisaSatisfacaoResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/pesquisas-satisfacao/${idPesquisaSatisfacao}/delete`);
            const response = handleAxiosResponse<DeletePesquisaSatisfacaoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getAllPesquisaSatisfacaoItem(request: GetAllPesquisaSatisfacaoItemRequest): Promise<GetAllPesquisaSatisfacaoItemResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/pesquisa-satisfacao-itens`, request);
            const response = handleAxiosResponse<GetAllPesquisaSatisfacaoItemResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async createPesquisaSatisfacaoItem(request: CreatePesquisaSatisfacaoItemRequest): Promise<CreatePesquisaSatisfacaoItemResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/pesquisa-satisfacao-itens/create`, request);
            const response = handleAxiosResponse<CreatePesquisaSatisfacaoItemResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async updatePesquisaSatisfacaoItem(request: UpdatePesquisaSatisfacaoItemRequest): Promise<UpdatePesquisaSatisfacaoItemResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/pesquisa-satisfacao-itens/update`, request);
            const response = handleAxiosResponse<UpdatePesquisaSatisfacaoItemResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async deletePesquisaSatisfacaoItem({ idItemPesquisaSatisfacao }: DeletePesquisaSatisfacaoItemRequest): Promise<DeletePesquisaSatisfacaoItemResponse> {
        try {
            const result = await axiosInstance({}).delete(`/entregaObras/pesquisa-satisfacao-itens/${idItemPesquisaSatisfacao}/delete`);
            const response = handleAxiosResponse<DeletePesquisaSatisfacaoItemResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getAllCategoriaAssistencia(request: GetAllCategoriaAssistenciaRequest): Promise<GetAllCategoriaAssistenciaResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/categoria-assistencias`, request);
            const response = handleAxiosResponse<GetAllCategoriaAssistenciaResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async createCategoriaAssistencia(request: CreateCategoriaAssistenciaRequest): Promise<CreateCategoriaAssistenciaResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/categoria-assistencias/create`, request);
            const response = handleAxiosResponse<CreateCategoriaAssistenciaResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async updateCategoriaAssistencia(request: UpdateCategoriaAssistenciaRequest): Promise<UpdateCategoriaAssistenciaResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/categoria-assistencias/update`, request);
            const response = handleAxiosResponse<UpdateCategoriaAssistenciaResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async deleteCategoriaAssistencia({ idCategoriaAssistencia }: DeleteCategoriaAssistenciaRequest): Promise<DeleteCategoriaAssistenciaResponse> {
        try {
            const result = await axiosInstance({}).delete(`/entregaObras/categoria-assistencias/${idCategoriaAssistencia}/delete`);
            const response = handleAxiosResponse<DeleteCategoriaAssistenciaResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getAllAssistenciaTecnica(request: GetAllAssistenciaTecnicaRequest): Promise<GetAllAssistenciaTecnicaResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/assistencias-tecnicas`, request);
            const response = handleAxiosResponse<GetAllAssistenciaTecnicaResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getAssistenciaTecnicaById({ idAssistenciaTecnica }: GetAssistenciaTecnicaByIdRequest): Promise<GetAssistenciaTecnicaByIdResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/assistencias-tecnicas/${idAssistenciaTecnica}`);
            const response = handleAxiosResponse<GetAssistenciaTecnicaByIdResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async createAssistenciaTecnica(request: CreateAssistenciaTecnicaRequest): Promise<CreateAssistenciaTecnicaResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/assistencias-tecnicas/create`, request);
            const response = handleAxiosResponse<CreateAssistenciaTecnicaResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async updateAssistenciaTecnica(request: UpdateAssistenciaTecnicaRequest): Promise<UpdateAssistenciaTecnicaResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/assistencias-tecnicas/update`, request);
            const response = handleAxiosResponse<UpdateAssistenciaTecnicaResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async deleteAssistenciaTecnica({ idAssistenciaTecnica }: DeleteAssistenciaTecnicaRequest): Promise<DeleteAssistenciaTecnicaResponse> {
        try {
            const result = await axiosInstance({}).delete(`/entregaObras/assistencias-tecnicas/${idAssistenciaTecnica}/delete`);
            const response = handleAxiosResponse<DeleteAssistenciaTecnicaResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getAllAssistenciaRegistroAtendimento({ idAssistenciaTecnica, ...request }: GetAllAssistenciaRegistroAtendimentoRequest): Promise<GetAllAssistenciaRegistroAtendimentoResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/assistencias-tecnicas/${idAssistenciaTecnica}/registros-atendimento`, request);
            const response = handleAxiosResponse<GetAllAssistenciaRegistroAtendimentoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getAllAssistenciaPesquisaSatisfacao({ idAssistenciaTecnica, ...request }: GetAllAssistenciaPesquisaSatisfacaoRequest): Promise<GetAllAssistenciaPesquisaSatisfacaoResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/assistencias-tecnicas/${idAssistenciaTecnica}/pesquisas-satisfacao`, request);
            const response = handleAxiosResponse<GetAllAssistenciaPesquisaSatisfacaoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getAllAssistenciaArquivoDiverso({ idAssistenciaTecnica, ...request }: GetAllAssistenciaArquivoDiversoRequest): Promise<GetAllAssistenciaArquivoDiversoResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/assistencias-tecnicas/${idAssistenciaTecnica}/arquivos-diversos`, request);
            const response = handleAxiosResponse<GetAllAssistenciaArquivoDiversoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getAllAssistenciaCategoria({ idAssistenciaTecnica, ...request }: GetAllAssistenciaCategoriaRequest): Promise<GetAllAssistenciaCategoriaResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/assistencias-tecnicas/${idAssistenciaTecnica}/categorias`, request);
            const response = handleAxiosResponse<GetAllAssistenciaCategoriaResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async createAssistenciaRegistroAtendimento({ idAssistenciaTecnica, ...request }: CreateAssistenciaRegistroAtendimentoRequest): Promise<CreateAssistenciaRegistroAtendimentoResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/assistencias-tecnicas/${idAssistenciaTecnica}/registros-atendimento/create`, request);
            const response = handleAxiosResponse<CreateAssistenciaRegistroAtendimentoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async updateAssistenciaRegistroAtendimento({ idAssistenciaTecnica, ...request }: UpdateAssistenciaRegistroAtendimentoRequest): Promise<UpdateAssistenciaRegistroAtendimentoResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/assistencias-tecnicas/${idAssistenciaTecnica}/registros-atendimento/update`, request);
            const response = handleAxiosResponse<UpdateAssistenciaRegistroAtendimentoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async deleteAssistenciaRegistroAtendimento({ idAssistenciaTecnica, idAssistenciaAtendimento }: DeleteAssistenciaRegistroAtendimentoRequest): Promise<DeleteAssistenciaRegistroAtendimentoResponse> {
        try {
            const result = await axiosInstance({}).delete(`/entregaObras/assistencias-tecnicas/${idAssistenciaTecnica}/registros-atendimento/${idAssistenciaAtendimento}/delete`);
            const response = handleAxiosResponse<DeleteAssistenciaRegistroAtendimentoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async createAssistenciaPesquisaSatisfacao({ idAssistenciaTecnica, ...request }: CreateAssistenciaPesquisaSatisfacaoRequest): Promise<CreateAssistenciaPesquisaSatisfacaoResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/assistencias-tecnicas/${idAssistenciaTecnica}/pesquisas-satisfacao/create`, request);
            const response = handleAxiosResponse<CreateAssistenciaPesquisaSatisfacaoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async deleteAssistenciaPesquisaSatisfacao({ idAssistenciaTecnica, idPesquisaSatisfacaoCliente }: DeleteAssistenciaPesquisaSatisfacaoRequest): Promise<DeleteAssistenciaPesquisaSatisfacaoResponse> {
        try {
            const result = await axiosInstance({}).delete(`/entregaObras/assistencias-tecnicas/${idAssistenciaTecnica}/pesquisas-satisfacao/${idPesquisaSatisfacaoCliente}/delete`);
            const response = handleAxiosResponse<DeleteAssistenciaPesquisaSatisfacaoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async createAssistenciaArquivoDiverso({ idAssistenciaTecnica, ...request }: CreateAssistenciaArquivoDiversoRequest): Promise<CreateAssistenciaArquivoDiversoResponse> {
        try {
            const formData = RequestObjectToFormData(request);
            const options = { headers: { "Content-Type": "multipart/form-data" } };
            const result = await axiosInstance({}).post(`/entregaObras/assistencias-tecnicas/${idAssistenciaTecnica}/arquivos-diversos/create`, formData, options);
            const response = handleAxiosResponse<CreateAssistenciaArquivoDiversoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async updateAssistenciaArquivoDiverso({ idAssistenciaTecnica, ...request }: UpdateAssistenciaArquivoDiversoRequest): Promise<UpdateAssistenciaArquivoDiversoResponse> {
        try {
            const formData = RequestObjectToFormData(request);
            const options = { headers: { "Content-Type": "multipart/form-data" } };
            const result = await axiosInstance({}).post(`/entregaObras/assistencias-tecnicas/${idAssistenciaTecnica}/arquivos-diversos/update`, formData, options);
            const response = handleAxiosResponse<UpdateAssistenciaArquivoDiversoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async deleteAssistenciaArquivoDiverso({ idAssistenciaTecnica, idAssistenciaArquivo }: DeleteAssistenciaArquivoDiversoRequest): Promise<DeleteAssistenciaArquivoDiversoResponse> {
        try {
            const result = await axiosInstance({}).delete(`/entregaObras/assistencias-tecnicas/${idAssistenciaTecnica}/arquivos-diversos/${idAssistenciaArquivo}/delete`);
            const response = handleAxiosResponse<DeleteAssistenciaArquivoDiversoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async downloadAssistenciaArquivoDiverso({ idAssistenciaTecnica, idAssistenciaArquivo }: DownloadAssistenciaArquivoDiversoRequest): Promise<Blob> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/assistencias-tecnicas/${idAssistenciaTecnica}/arquivos-diversos/${idAssistenciaArquivo}/download`, {
                responseType: 'blob'
            });
            const response = handleAxiosResponse<Blob>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    // FIM VITOR



    //#region  EntregaObrasCliente

    async getAllEntregaObrasClienteLista(request: GetAllEntregaObraClienteRequest): Promise<GetAllEntregaObraClienteResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/entrega-obra-cliente/all`, request);
            const response = handleAxiosResponse<GetAllEntregaObraClienteResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getAllVerificacaoChecklistLista(request: GetAllVerificacaoChecklistEntregaRequest): Promise<GetAllVerificacaoChecklistEntregaResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/entrega-obra-cliente/verificacao-checklist/${request.idEntregaObraCliente}`);
            const response = handleAxiosResponse<GetAllVerificacaoChecklistEntregaResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getEntregaObrasClienteChecklistById(request: GetEntregaObrasClienteChecklistRequest): Promise<GetEntregaObrasClienteChecklistResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/entrega-obra-cliente/get/${request.idEntregaObraCliente}`);
            const response = handleAxiosResponse<GetEntregaObrasClienteChecklistResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }



    async deleteEntregaObraClienteById(idEntregaObraCliente: number): Promise<void> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/entrega-obra-cliente/delete/${idEntregaObraCliente}`);
            const response = handleAxiosResponse<void>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async createEntregaObrasCliente(request: CreateEntregaObraClienteRequest): Promise<CreateEntregaObraClienteResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/entrega-obra-cliente/create`, request);
            const response = handleAxiosResponse<CreateEntregaObraClienteResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async updateEntregaObrasClienteChecklistById(request: UpdateEntregaObrasClienteChecklistRequest): Promise<UpdateEntregaObrasClienteChecklistResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/entrega-obra-cliente/update`, request);
            const response = handleAxiosResponse<UpdateEntregaObrasClienteChecklistResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }


    //#endregion


    //#region EntregaObrasArquivos

    async getAllEntregaObrasClienteArquivos(request: GetAllEntregaObraClienteArquivoRequest): Promise<GetAllEntregaObraClienteArquivoResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/entrega-obra-cliente/arquivos/${request.idEntregaObra}`);
            const response = handleAxiosResponse<GetAllEntregaObraClienteArquivoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getEntregaObrasClienteArquivos(request: GetEntregaObraClienteArquivoByIdRequest): Promise<GetEntregaObraClienteArquivoByIdResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/entrega-obra-cliente/arquivo/${request.idEntregaObraClienteArquivo}`);
            const response = handleAxiosResponse<GetEntregaObraClienteArquivoByIdResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }


    async createEntregaObrasClienteArquivos(request: CreateEntregaObraClienteArquivoRequest): Promise<CreateEntregaObraClienteArquivoResponse> {
        try {
            const formData = RequestObjectToFormData(request);
            const options = { headers: { "Content-Type": "multipart/form-data" } };
            const result = await axiosInstance({}).post(`/entregaObras/entrega-obra-cliente/arquivo/create`, formData, options);
            const response = handleAxiosResponse<CreateEntregaObraClienteArquivoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async updateEntregaObrasClienteArquivos(request: UpdateEntregaObraClienteArquivoRequest): Promise<UpdateEntregaObraClienteArquivoResponse> {
        try {
            const formData = RequestObjectToFormData(request);
            const options = { headers: { "Content-Type": "multipart/form-data" } };
            const result = await axiosInstance({}).post(`/entregaObras/entrega-obra-cliente/arquivo/update`
                , formData
                , options);
            const response = handleAxiosResponse<UpdateEntregaObraClienteArquivoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async deleteEntregaObrasClienteArquivos(idEntregaObraClienteArquivo: number): Promise<void> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/entrega-obra-cliente/arquivo/delete/${idEntregaObraClienteArquivo}`);
            const response = handleAxiosResponse<void>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async downloadEntregaObraClienteArquivoById(request: DownloadEntregaObraClienteArquivoRequest): Promise<Blob> {
        try {
            const result = await axiosInstance({})
                .get(`/entregaObras/entrega-obra-cliente/${request.idEntregaObraClienteArquivo}/arquivo`, {
                    responseType: 'blob'
                });
            const response = handleAxiosResponse<Blob>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    //#endregion



    //#region EntregaObrasClienteArquivosAux

    async getAllEntregaObrasClienteArquivosAux(request: GetAllEntregaObraClienteArquivoAuxRequest): Promise<GetAllEntregaObraClienteArquivoAuxResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/entrega-obra-cliente/arquivos-aux/all/${request.idEntregaObraCliente}`);
            const response = handleAxiosResponse<GetAllEntregaObraClienteArquivoAuxResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getEntregaObrasClienteArquivosAux(request: GetEntregaObraClienteArquivoAuxByIdRequest): Promise<GetEntregaObraClienteArquivoAuxByIdResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/entrega-obra-cliente/arquivo-aux/${request.idEntregaObraClienteArquivoAux}`);
            const response = handleAxiosResponse<GetEntregaObraClienteArquivoAuxByIdResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async createEntregaObrasClienteArquivosAux(request: CreateEntregaObraClienteArquivoAuxRequest): Promise<CreateEntregaObraClienteArquivoAuxResponse> {
        try {
            const formData = RequestObjectToFormData(request);
            const options = { headers: { "Content-Type": "multipart/form-data" } };
            const result = await axiosInstance({}).post(`/entregaObras/entrega-obra-cliente/arquivo-aux/create`, formData, options);
            const response = handleAxiosResponse<CreateEntregaObraClienteArquivoAuxResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async updateEntregaObrasClienteArquivosAux(request: UpdateEntregaObraClienteArquivoAuxRequest): Promise<UpdateEntregaObraClienteArquivoAuxResponse> {
        try {
            const formData = RequestObjectToFormData(request);
            const options = { headers: { "Content-Type": "multipart/form-data" } };
            const result = await axiosInstance({}).post(`/entregaObras/entrega-obra-cliente/arquivo-aux/update`, formData, options);
            const response = handleAxiosResponse<UpdateEntregaObraClienteArquivoAuxResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async deleteEntregaObrasClienteArquivosAux(idEntregaObraClienteArquivo: number): Promise<void> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/entrega-obra-cliente/arquivo-aux/delete/${idEntregaObraClienteArquivo}`);
            handleAxiosResponse<void>(result);
            return;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async downloadEntregaObrasClienteArquivosAuxById(request: DownloadEntregaObraClienteArquivoAuxRequest): Promise<Blob> {
        try {
            const result = await axiosInstance({})
                .get(`/entregaObras/entrega-obra-cliente/${request.idEntregaObraClienteArquivoAux}/arquivo-aux`, {
                    responseType: 'blob'
                });
            const response = handleAxiosResponse<Blob>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    //#endregion

    //#region EntregaObrasClienteTermos

    async getAllEntregaObrasClienteTermos(request: GetAllEntregaObraClienteTermoRequest): Promise<GetAllEntregaObraClienteTermoResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/entrega-obra-cliente/termos/all/${request.idEntregaObraCliente}`);
            const response = handleAxiosResponse<GetAllEntregaObraClienteTermoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async createEntregaObrasClienteTermo(request: CreateEntregaObraClienteTermoRequest): Promise<CreateEntregaObraClienteTermoResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/entrega-obra-cliente/termo/create`, request);
            const response = handleAxiosResponse<CreateEntregaObraClienteTermoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async deleteEntregaObrasClienteTermo(idEntregaObraClienteTermo: number): Promise<void> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/entrega-obra-cliente/termo/delete/${idEntregaObraClienteTermo}`);
            handleAxiosResponse<void>(result);
            return;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    //#endregion





    //#region InformacoesEntregaObrasCliente

    async getAllInformacoesEntregaObrasCliente(request: GetAllInformacoesEntregaObraClienteRequest): Promise<GetAllInformacoesEntregaObraClienteResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/entrega-obra-cliente/informacoes/all/${request.idEntregaObraCliente}`);
            const response = handleAxiosResponse<GetAllInformacoesEntregaObraClienteResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getInformacoesEntregaObrasCliente(request: GetInformacoesEntregaObraClienteByIdRequest): Promise<GetInformacoesEntregaObraClienteByIdResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/entrega-obra-cliente/informacao/${request.idInformacoesEntregaObraCliente}`);
            const response = handleAxiosResponse<GetInformacoesEntregaObraClienteByIdResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async createInformacoesEntregaObrasCliente(request: CreateInformacoesEntregaObraClienteRequest): Promise<CreateInformacoesEntregaObraClienteResponse> {
        try {
            const formData = RequestObjectToFormData(request);
            const options = { headers: { "Content-Type": "multipart/form-data" } };
            const result = await axiosInstance({}).post(`/entregaObras/entrega-obra-cliente/informacao/create`, formData, options);
            const response = handleAxiosResponse<CreateInformacoesEntregaObraClienteResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async updateInformacoesEntregaObrasCliente(request: UpdateInformacoesEntregaObraClienteRequest): Promise<UpdateInformacoesEntregaObraClienteResponse> {
        try {
            const formData = RequestObjectToFormData(request);
            const options = { headers: { "Content-Type": "multipart/form-data" } };
            const result = await axiosInstance({}).post(`/entregaObras/entrega-obra-cliente/informacao/update`, formData, options);
            const response = handleAxiosResponse<UpdateInformacoesEntregaObraClienteResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async deleteInformacoesEntregaObrasCliente(idInformacoesEntregaObraCliente: number): Promise<void> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/entrega-obra-cliente/informacao/delete/${idInformacoesEntregaObraCliente}`);
            handleAxiosResponse<void>(result);
            return;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async downloadInfoEntregaObrasClienteArquivosById(idInformacoesEntregaObraCliente: number, nroArquivo: number): Promise<Blob> {
        try {
            const result = await axiosInstance({})
                .get(`/entregaObras/entrega-obra-cliente/informacao/${idInformacoesEntregaObraCliente}/arquivo/${nroArquivo}`, {
                    responseType: 'blob'
                });
            const response = handleAxiosResponse<Blob>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    //#endregion




    //#region EntregaObrasClientePesquisaSatisfacao

    async getAllEntregaObrasClientePesquisaSatisfacao(
        request: GetAllEntregaPesquisaSatisfacaoRequest
    ): Promise<GetAllEntregaPesquisaSatisfacaoResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/entrega_obras_cliente/pesquisas-satisfacao/getlista/${request.idEntregaObraCliente}`);
            const response = handleAxiosResponse<GetAllEntregaPesquisaSatisfacaoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async getEntregaObrasClientePesquisaSatisfacaoById(
        request: GetEntregaPesquisaSatisfacaoByIdRequest
    ): Promise<GetEntregaPesquisaSatisfacaoByIdResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/entrega_obras_cliente/pesquisas-satisfacao/${request.idEntregaPesquisa}`);
            const response = handleAxiosResponse<GetEntregaPesquisaSatisfacaoByIdResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async createEntregaObrasClientePesquisaSatisfacao(
        request: CreateEntregaPesquisaSatisfacaoRequest
    ): Promise<CreateEntregaPesquisaSatisfacaoResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/entrega_obras_cliente/${request.idEntregaObraCliente}/pesquisas-satisfacao/${request.idPesquisaSatisfacao}/create`);
            const response = handleAxiosResponse<CreateEntregaPesquisaSatisfacaoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }

    async updateEntregaObrasClientePesquisaSatisfacao(
        request: UpdateEntregaPesquisaSatisfacaoRequest
    ): Promise<UpdateEntregaPesquisaSatisfacaoResponse> {
        try {
            const result = await axiosInstance({}).post(`/entregaObras/entrega_obras_cliente/pesquisas-satisfacao/update`, request);
            const response = handleAxiosResponse<UpdateEntregaPesquisaSatisfacaoResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }


    async deleteEntregaObrasClientePesquisaSatisfacao(idEntregaPesquisa: number): Promise<void> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/entrega-obras-cliente/pesquisa-satisfacao/delete/${idEntregaPesquisa}`);
            handleAxiosResponse<void>(result);
            return;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    };

    //#endregion

    async getDashboardEntregaObrasInformation(request: GetDashboardEntregaObrasInformationRequest): Promise<GetDashboardEntregaObrasInformationResponse> {
        try {
            const result = await axiosInstance({}).get(`/entregaObras/dashboard/information`);
            const response = handleAxiosResponse<GetDashboardEntregaObrasInformationResponse>(result);
            return response;
        } catch (error: unknown) {
            if (typeof error === "string") {
                throw new Error(error);
            } else if (isBaseError(error)) {
                throw toBaseError(error);
            } else if (error instanceof AxiosError) {
                throw new Error(error.message);
            } else if (error instanceof Error) {
                throw error;
            } else {
                throw new Error("Falha ao executar requisição!");
            }
        }
    }
}
